import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useEventBusStore = defineStore('eventBus', () => {
  // Un ref qui contient l'événement en cours (ou un identifiant)
  const lastEvent = ref<null | string>(null)
  const lastEventData = ref<any>(null)

  // Fonction pour déclencher un événement
  function trigger(event: string, data?: any) {
    lastEvent.value = event
    lastEventData.value = data

    // Reset après un court délai pour permettre de redéclencher le même nom plus tard
    setTimeout(() => {
      lastEvent.value = null
      lastEventData.value = null
    }, 100)
  }

  return {
    lastEvent,
    lastEventData,
    trigger,
  }
})